
























































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {PMStrategy, PMStrategyService} from '@/domain/PMStrategy'
import User from '@/domain/User'
import ExposureRadar from '@/components/ExposureRadar.vue'
import PerformanceChart from '@/components/PerformanceChart.vue'
import {PMStrategyPerformance, PMStrategyPerformanceService} from '@/domain/PMStrategyPerformance'
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'
import env from '@//util/Env'
import Const from '@/util/Const'
import Dialog from '@/components/Dialog.vue'
import {EstimationMile, Program} from '@/domain/Program'
import AppDownload from '@/components/AppDownload.vue'
import {State} from '@/views/diagnosis/Index.vue'

@Component({
  components: {
    ExposureRadar, PerformanceChart, RangeSlider, Dialog, AppDownload,
  },
})
export default class Result extends Vue {
  @Prop({type: Object, required: true})
  public state!: State
  private pmStrategy: PMStrategy | null = null
  private performance: PMStrategyPerformance | null = null
  private start = 30
  private deposit = 3
  private con = Const
  private estimationMile: EstimationMile | null = null

  public async created() {
    const pms = this.state.pms
    if (!pms) {
      await this.$router.push('./')
      return
    }

    this.pmStrategy = await PMStrategyService.get(pms)
    await this.updatePerformance()
  }

  get exposures(): number[] {
    const exp = this.pmStrategy?.idealExposures
    if (!exp) {
      return [0, 0, 0, 0, 0, 0, 0, 0]
    }
    return [
      exp.exposure1,
      exp.exposure2,
      exp.exposure3,
      exp.exposure4,
      exp.exposure5,
      exp.exposure6,
      exp.exposure7,
      exp.exposure8,
    ]
  }

  get topix(): number {
    const exp = this.pmStrategy?.idealExposures
    if (!exp) {
      return 50
    }
    return exp.topix
  }

  public num(n: number | string, isOperator: boolean) {
    n = Number(n)
    if (n > 0) {
      return `${isOperator ? '+' : ''}${n.toFixed(1)}`
    } else {
      return `${n.toFixed(1)}`
    }
  }

  public async updatePerformance() {
    this.performance = await PMStrategyPerformanceService.get(
        this.pmStrategy!.code,
        this.start * 10000,
        this.deposit * 10000,
    )
    this.estimationMile = await Program.getEstimationMile(
        this.start * 10000,
        this.deposit * 10000,
    )
  }

  get performanceDiff(): string {
    const last = this.performance?.chartData[this.performance?.chartData.length - 1]
    if (!last) {
      return ''
    }
    return this.num((last.value - last.bookValue) / 10000, true)
  }

  get width(): number {
    if (window.innerWidth < 860) {
      return window.innerWidth - 60
    }
    return 800
  }

  get height(): number {
    return this.width * 0.63
  }

  get isSp(): boolean {
    return window.innerWidth <= 780
  }

  get mile(): string | undefined {
    return this.estimationMile?.halfAYear.toLocaleString('ja-JP')
  }

  public openAccount() {
    User.setDiagnosisResult(this.pmStrategy?.code || '', this)
    window.location.href = `${env.OpenAccountUrl}?redirectToSignUp=true`
  }
}
